import { CButton, CCol, CRow } from "@coreui/react";
import React from "react";

const LotListViewTransferLotEMDPayment = (props) => {
  return (
    <>
      <CRow className="pt-3" xl={12}>
        <CCol className="mb-2" xl={12}>
          <h5 className="titlehr">Transfer lot EMD payment</h5>
        </CCol>
      </CRow>
      <CRow className={"mb-2"}>
        <CCol xs={3}>
          <CCol>
            <strong className="ml-2">
              Amount : {props.viewListDetails.amount25}
            </strong>
          </CCol>
          <CCol>
            <CButton
              className="mt-2 ml-2 mr-2"
              color="success"
              variant="outline"
              disabled={
                props.viewListDetails.isTransferLotEMDPaid === true ||
                props.viewListDetails.isTransferLotEMD25Paid === true ||
                props.viewListDetails.isTransferLotEMD15Paid === true ||
                props.viewListDetails.isTransferLotEMD10Paid === true
                  ? true
                  : false
              }
              //onClick={() => props.TransferLotEMDPayment(25)}
              onClick={() =>
                props.ConfirmationPopupHandler(
                  4,
                  1,
                  "Are you sure you want to pay via Online?",
                  props.viewListDetails.fullPaymentInstallmentAmount,
                  props.FullPaymentLotDetails.id,
                  0,
                  props.viewListDetails.additionalSDAmountForFinalPayment,
                  0,
                  0,
                  0,
                  0,
                  25,
                  false,
                  ""
                )
              }
            >
              Pay 25% VIA Online Transfer
            </CButton>
          </CCol>
          <CCol>
            {props.viewListDetails.lottransfer25emdpaymentdescription !==
              undefined &&
              props.viewListDetails.lottransfer25emdpaymentdescription !== "" &&
              props.viewListDetails.lottransfer25emdpaymentdescription !==
                null && (
                <>
                  <br />
                  {props.viewListDetails.lottransfer25emdpaymentdescription}
                  <br />
                  <CButton
                    color="info"
                    onClick={() =>
                      props.PaymentStatusViewHanlder(
                        props.viewListDetails.lottransfer25emdpaymentidtranId
                      )
                    }
                    className="mr-5 mt-1 float-right"
                  >
                    View Receipt
                  </CButton>
                </>
              )}
          </CCol>
        </CCol>
        <CCol xs={1} className="mt-2">
          OR
        </CCol>
        <CCol xs={4}>
          <CCol>
            <strong>Amount : {props.viewListDetails.amount10}</strong>
          </CCol>
          <CCol>
            <CButton
              className="mt-2 mr-2"
              color="success"
              variant="outline"
              disabled={
                props.viewListDetails.isTransferLotEMDPaid === true ||
                props.viewListDetails.isTransferLotEMD10Paid === true
                  ? true
                  : false
              }
              // onClick={() => props.TransferLotEMDPayment(10)}
              onClick={() =>
                props.ConfirmationPopupHandler(
                  4,
                  1,
                  "Are you sure you want to pay via Online?",
                  props.viewListDetails.fullPaymentInstallmentAmount,
                  props.FullPaymentLotDetails.id,
                  0,
                  props.viewListDetails.additionalSDAmountForFinalPayment,
                  0,
                  0,
                  0,
                  0,
                  10
                )
              }
            >
              Pay 10% VIA Online Transfer
            </CButton>
          </CCol>
          {props.viewListDetails.lottransfer10emdpaymentdescription !==
            undefined &&
          props.viewListDetails.lottransfer10emdpaymentdescription !== "" &&
          props.viewListDetails.lottransfer10emdpaymentdescription !== null ? (
            <>
              <CCol>
                {props.viewListDetails.lottransfer10emdpaymentdescription}
              </CCol>
              <CCol>
                <CButton
                  color="info"
                  onClick={() =>
                    props.PaymentStatusViewHanlder(
                      props.viewListDetails.lottransfer10emdpaymentidtranId
                    )
                  }
                  className="mr-5 mt-1 float-right"
                >
                  View Receipt
                </CButton>
              </CCol>
            </>
          ) : (
            ""
          )}
        </CCol>
        {/* {props.viewListDetails.isTransferLotEMDPaid == true
                    ? "true"
                    : "false"}
                  -
                  {props.viewListDetails.isTransferLotEMD15Paid == true
                    ? "true"
                    : "false"} */}
        <CCol xs={4}>
          <CCol>
            <strong className="ml-2">
              Amount : {props.viewListDetails.amount15}
            </strong>
          </CCol>
          {props.viewListDetails.lottransferEMD15_BGID && (
            <CCol>
              {props.viewListDetails.lottransferEMD15_BGID} -{" "}
              {props.viewListDetails.lottransferEMD15_BGStatus}
            </CCol>
          )}
          <CCol>
            <CButton
              className="mt-2 ml-2 mr-2"
              color="success"
              variant="outline"
              disabled={
                props.viewListDetails.isTransferLotEMDPaid === true ||
                props.viewListDetails.isTransferLotEMD15Paid === true
                  ? true
                  : props.viewListDetails.lottransferEMD15_BGID !== "" &&
                    props.viewListDetails.lottransferEMD15_BGStatus !==
                      "Rejected"
                  ? true
                  : false
              }
              onClick={() => props.TransferLotEMDPayment(15)}
            >
              Pay 15% VIA Online Transfer/BG/FDR
            </CButton>
          </CCol>
          {props.viewListDetails.lottransfer15emdpaymentdescription !==
            undefined &&
          props.viewListDetails.lottransfer15emdpaymentdescription !== "" &&
          props.viewListDetails.lottransfer15emdpaymentdescription !== null ? (
            <>
              <CCol>
                {props.viewListDetails.lottransfer15emdpaymentdescription}
              </CCol>
              <CCol>
                {props.viewListDetails.is15EmdTransferBG === true ? (
                  // <a
                  //   target="_blank"
                  //   href={`${downloadUrl}/${props.viewListDetails.bgPath15EmdTransferlotfilepath}`}
                  //   rel="noreferrer"
                  // >
                  <CButton
                    color="info"
                    className="mr-5 mt-1 float-right"
                    onClick={() =>
                      props.props.BGPaymentStatusViewHanlder(
                        props.viewListDetails.bgPath15EmdTransferlotfilepath
                      )
                    }
                  >
                    View BG
                  </CButton>
                ) : (
                  // </a>
                  <CButton
                    color="info"
                    hidden={
                      props.viewListDetails.lottransfer15emdpaymentid > 0
                        ? false
                        : true
                    }
                    onClick={() =>
                      props.PaymentStatusViewHanlder(
                        props.viewListDetails.lottransfer15emdpaymentidtranId
                      )
                    }
                    className="mr-5 mt-1 float-right"
                  >
                    View Receipt
                  </CButton>
                )}
              </CCol>
            </>
          ) : (
            ""
          )}
        </CCol>
      </CRow>
    </>
  );
};

export default LotListViewTransferLotEMDPayment;
